import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import WalletBalance from '../components/WalletBalance';
import RequestPayoutModal from '../components/RequestPayoutModal';
import { useAuth } from '../authContext';
import BottomNav from '../BottomNav';
import './WalletPage.css';

const MINIMUM_PAYOUT = 100;

const WalletPage = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [balance, setBalance] = useState(0);
  const [payoutStatus, setPayoutStatus] = useState('none');
  const [showPayoutModal, setShowPayoutModal] = useState(false);

  const handleBalanceChange = useCallback((bal) => setBalance(bal), []);

  useEffect(() => {
    if (!currentUser) return;
    const userDocRef = doc(db, 'users', currentUser.uid);
    const unsubscribe = onSnapshot(userDocRef, (snap) => {
      setPayoutStatus(snap.exists() ? (snap.data().payoutStatus || 'none') : 'none');
    });
    return () => unsubscribe();
  }, [currentUser]);

  if (!currentUser) {
    return (
      <div className="wallet-page">
        <div className="wallet-error">
          <h2>Access Denied</h2>
          <p>Please log in to view your wallet.</p>
        </div>
      </div>
    );
  }

  const isPending = payoutStatus === 'pending';
  const isBelowMinimum = balance < MINIMUM_PAYOUT;
  const isButtonDisabled = isPending || isBelowMinimum;
  const buttonLabel = isPending ? 'Processing Payment' : 'Request Payout';

  return (
    <div className="wallet-page">
      <div className="wallet-header">
        <img
          src={require('../assets/back.png')}
          alt="Back"
          className="wallet-back-btn"
          onClick={() => navigate('/profile')}
        />
        <h1 className="wallet-title">My Wallet</h1>
      </div>

      <div className="wallet-balance-section">
        <WalletBalance showDetails={true} onBalanceChange={handleBalanceChange} />
      </div>

      <div className="wallet-actions">
        <button
          className={`action-button-wallet primary${isButtonDisabled ? ' disabled' : ''}`}
          onClick={() => !isButtonDisabled && setShowPayoutModal(true)}
          disabled={isButtonDisabled}
        >
          {isPending && <span className="processing-dot" />}
          {buttonLabel}
        </button>
      </div>

      {isBelowMinimum && !isPending && (
        <p className="wallet-hint">Minimum ₹100 balance required to request a payout.</p>
      )}

      {showPayoutModal && (
        <RequestPayoutModal
          currentUser={currentUser}
          balance={balance}
          onClose={() => setShowPayoutModal(false)}
        />
      )}

      <BottomNav />
    </div>
  );
};

export default WalletPage;